export default __webpack_public_path__ + "static/media/badge_7_volcano.daf228ac.png";